import React from "react";
import './style.css';

export function Footer(){
    return(
        <footer className="footer">
            <div className="wrapper"> 
                <a href="https://rs.school/js/" className="footer-link rsschool" target="_blank" rel="noreferrer">
                    <img className="footer-icon" src="https://rs.school/images/rs_school_js.svg" alt="" />
                </a>
                <span>2022</span>
                <a href="https://github.com/badikgit/" className="footer-link github" target="_blank" rel="noreferrer">
                    <img className="footer-icon" src="https://badikgit.github.io/rsschool-cv/image/icon/icon-github-footer.svg" alt="" />
                    <span>badikgit</span>
                </a>
            </div>
        </footer>
    );
}
